export function elementHasParentQuerySelector (element, querySelector, maxRecursion = 5) {
  const checkElement = (recursionCount = 0) => {
    if (!element) {
      return false;
    }
    if (element.matches(querySelector)) {
      return true;
    }
    element = element.parentElement;
    return recursionCount < maxRecursion ? checkElement(++recursionCount) : false;
  };

  return checkElement();
}
